import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";
import socialModule from "./socialModule.js";
import notification from "./notification.js";
import account from "./account.js";
import definition from "./definition.js";
import { Message } from "element-ui";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    socialModule,
    notification,
    account,
    definition
  },
  state: {
    mobileBackPath: null,
    liveSesionHash: null,
    eventDetailLoading: true,
    eventLoading: true,
    response: {
      message: null,
      validationErrors: [],
      hasError: false
    },
    socialAlbumList: [],
    application: null,
    event: null,
    organisation: null,
    isAttending: false,
    participants: [],
    groups: [],
    sponsors: [],
    sponsorCategories: [],
    speakers: [],
    currentSpeaker: null,
    currentSpeakerPrograms: [],
    program: [],
    mysubeventregistrations: [],
    myProgramRates: [],
    programRates: [],
    currentProgram: null,
    programDays: [],
    programSaloons: [],
    programSpeakers: [],
    subEvents: [],
    registrationFormUrls: [],
    documents: [],
    documentCategories: [],
    faqs: [],
    album: [],
    maps: [],
    sessions: [],
    currentSession: null,
    rooms: [],
    currentRoom: null,
    booths: [],
    boothSaloons: [],
    currentBooth: null,

    user: null,
    token: localStorage.getItem("token"),
    unreadMessages: 0,
    unreadNotifications: 0,
    participant: null,

    activeChatPanelId: null,
    currentUserProfile: null,
    currentEventProgram: null,
    currentSpeakerProfile: null,
    tokbox: null,
    streams: [],
    chats: [],
    lastApplication: localStorage.getItem("lastApplication"),
    rates: [],
    mySubEvents: [],
    publishers: [],
    sessionLoadingID: null,
    eventBoxes: [],
    consumers: [],
    dataConsumers: [],
    dataProducers: [],
    id: "",
    displayName: "",
    displayNameSet: false, // true if got from cookie or manually set.
    device: { flag: "", name: "", version: "" },
    canSendMic: true,
    canSendWebcam: true,
    canChangeWebcam: false,
    webcamInProgress: false,
    shareInProgress: false,
    audioOnly: false,
    audioOnlyInProgress: false,
    audioMuted: false,
    restartIceInProgress: false,
    notifications: [],
    peers: [],
    producers: [],
    url: "",
    state: "", // new/connecting/connected/closed
    activeSpeakerId: "",
    statsPeerId: null,
    faceDetection: false,
    settingsModal:false,
    sidebarIsOpen: false,
    addPerson:false,
    me: {
      id: "",
      displayName: "",
      image: "",
      displayNameSet: false, // true if got from cookie or manually set.
      device: { flag: "", name: "", version: "" },
      canSendMic: true,
      canSendWebcam: true,
      canChangeWebcam: false,
      webcamInProgress: false,
      shareInProgress: false,
      audioOnly: false,
      audioOnlyInProgress: false,
      audioMuted: false,
      restartIceInProgress: false
    },
    room: {
      url: "",
      state: "", // new/connecting/connected/closed
      activeSpeakerId: "",
      statsPeerId: null,
      faceDetection: false
    }
  },
  mutations: {
    removeSession(state, payload) {
      state.sessions = state.sessions.filter(x => x.id != payload);
    },
    removeNetworking(state, payload) {
      state.rooms = state.rooms.filter(x => x.id != payload);
      // if (state.currentRoom != null && state.currentRoom.id == payload) {
      //   state.currentRoom = null;
      // }
    },
    updateSession(state, payload) {
      state.rooms[payload.index] = payload.data;
      Vue.set(state, "rooms", [...state.rooms]);
    },
    clearSocialAlbum(state) {
      state.socialAlbumList = [];
    },
    setLiveSessionHash(state, payload) {
      state.liveSesionHash = payload;
    },
    setSocialAlbumList(state, payload) {
      state.socialAlbumList.push(...payload);
    },
    setUser(state, user) {
      state.user = user;
    },
    setJob(state, job) {
      state.user.jobs[job.index] = job;
    },
    setToken(state, token) {
      state.token = token;
      axios.defaults.headers["Authorization"] = "Bearer " + token;
    },
    setNotify(state, user) {
      state.unreadMessages = user.unreadMessages;
      state.unreadNotifications = user.unreadNotifications;
    },
    setApplication(state, payload) {
      state.application = payload.item;
      axios.defaults.headers["applicationID"] = payload.item.id;
    },
    setEvent(state, payload) {
      payload.modules = payload.modules.map(x => {
        if (x.isCustom) {
          x.name = x.title;
        }
        return x;
      });
      state.event = payload;
      axios.defaults.headers["eventID"] = payload.id;
    },
    setOrganisation(state, payload) {
      state.organisation = payload;
    },
    setSubEventRegistrations(state, payload) {
      state.mysubeventregistrations = payload;
    },
    setMyProgramRates(state, payload) {
      state.myProgramRates = payload;
    },
    setProgramRates(state, payload) {
      state.programRates = payload;
    },
    setAttending(state, payload) {
      state.isAttending = payload;
    },
    setParticipants(state, payload) {
      state.participants = payload;
    },
    setGroups(state, payload) {
      state.groups = payload;
    },
    setSponsors(state, payload) {
      state.sponsors = payload;
    },
    setSponsorCategories(state, payload) {
      state.sponsorCategories = payload;
    },
    setSpeakers(state, payload) {
      state.speakers = payload;
    },
    setCurrentSpeaker(state, payload) {
      state.currentSpeaker = payload;
    },
    setCurrentSpeakerPrograms(state, payload) {
      state.currentSpeakerPrograms = payload;
    },
    setProgram(state, payload) {
      state.program = payload;
    },
    setRegistrationFormUrls(state, payload) {
      state.registrationFormUrls = payload;
    },
    setCurrentProgram(state, payload) {
      state.currentProgram = payload;
    },
    setProgramDays(state, payload) {
      state.programDays = payload;
    },
    setProgramSaloons(state, payload) {
      state.programSaloons = payload;
    },
    setProgramSpeakers(state, payload) {
      state.programSpeakers = payload;
    },
    setSubEvents(state, payload) {
      state.subEvents = payload;
    },
    setDocuments(state, payload) {
      state.documents = payload;
    },
    setDocumentCategories(state, payload) {
      state.documentCategories = payload;
    },
    setFaqs(state, payload) {
      state.faqs = payload.map(x => {
        return { ...x, collapse: payload.findIndex(t => t.id == x.id) == 0 ? true : false };
      });
    },
    setAlbum(state, payload) {
      state.album = payload;
    },
    setMaps(state, payload) {
      state.maps = payload;
    },
    setSessions(state, payload) {
      state.sessions = payload;
      state.sessions = state.sessions.sort((a, b) => a.orderNO - b.orderNO);
    },
    setCurrentSession(state, payload) {
      state.currentSession = payload;
    },
    setRooms(state, payload) {
      state.rooms = payload;
      state.rooms = state.rooms.sort((a, b) => a.orderNO - b.orderNO);
    },
    setRoomIndex(state, payload) {},
    setCurrentRoom(state, payload) {
      state.currentRoom = payload;
    },
    setBooths(state, payload) {
      state.booths = payload;
    },
    setBoothSaloons(state, payload) {
      state.boothSaloons = payload;
    },
    setCurrentBooth(state, payload) {
      state.currentBooth = payload;
    },

    setParticipant(state, participant) {
      state.participant = participant;
      state.eventLoading = false;
    },
    setEventLoading(state, loading) {
      state.eventLoading = loading;
    },
    setLoading(state, loading) {
      state.eventDetailLoading = loading;
    },
    setSessions(state, sessions) {
      state.sessions = sessions;
      state.sessions = state.sessions.sort((a, b) => a.orderNO - b.orderNO);
    },
    setAddSession(state, data) {
      state.sessions.push(data);
      state.sessions = state.sessions.sort((a, b) => a.orderNO - b.orderNO);
    },
    setAddRoom(state, data) {
      state.rooms.push(data);
      state.rooms = state.rooms.sort((a, b) => a.orderNO - b.orderNO);
    },
    setSession(state, session) {
      state.session = session;
    },
    setTokbox(state, payload) {
      state.tokbox = payload;
    },
    updateSession(state, payload) {
      state.sessions[payload.index] = payload.data;
      Vue.set(state, "sessions", [...state.sessions]);
    },
    setRates(state, payload) {
      state.rates = payload;
    },
    setMySubEvents(state, payload) {
      state.mySubEvents = payload;
    },

    ////

    ConsumerssetRoomState(state, payload) {
      if (payload.state === "closed") {
        state.consumers = [];
      }
    },

    ConsumersaddConsumer(state, payload) {
      state.consumers.push(payload.consumer);
    },

    ConsumersremoveConsumer(state, payload) {
      const consumerId = payload.consumerId;

      state.consumers = state.consumers.filter(consumer => consumer.id !== consumerId);
    },

    ConsumerssetConsumerPaused(state, payload) {
      const { consumerId, originator } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      if (originator === "local") {
        Vue.set(consumer, "locallyPaused", true);
      } else {
        Vue.set(consumer, "remotelyPaused", true);
      }
    },

    ConsumerssetConsumerResumed(state, payload) {
      const { consumerId, originator } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      if (originator === "local") {
        Vue.set(consumer, "locallyPaused", false);
      } else {
        Vue.set(consumer, "remotelyPaused", false);
      }
    },

    ConsumerssetConsumerCurrentLayers(state, payload) {
      const { consumerId, spatialLayer, temporalLayer } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      Vue.set(consumer, "currentSpatialLayer", spatialLayer);
      Vue.set(consumer, "currentTemporalLayer", temporalLayer);
    },

    ConsumerssetConsumerPreferredLayers(state, payload) {
      const { consumerId, spatialLayer, temporalLayer } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      Vue.set(consumer, "preferredSpatialLayer", spatialLayer);
      Vue.set(consumer, "preferredTemporalLayer", temporalLayer);
    },

    ConsumerssetConsumerPriority(state, payload) {
      const { consumerId, priority } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      Vue.set(consumer, "priority", priority);
    },

    ConsumerssetConsumerTrack(state, payload) {
      const { consumerId, track } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      Vue.set(consumer, "track", track);
    },

    ConsumerssetConsumerScore(state, payload) {
      const { consumerId, score } = payload;
      const consumer = state.consumers.find(consumer => consumer.id === consumerId);

      if (consumer != null) {
        Vue.set(consumer, "score", score);
      }
    },

    ///

    ////

    ///data consumers

    DataConsumerssetRoomState(state, payload) {
      if (payload.state === "closed") {
        state.dataConsumers = [];
      }
    },

    DataConsumersaddDataConsumer(state, payload) {
      const { dataConsumer } = payload;
      state.dataConsumers.push(dataConsumer);
    },

    DataConsumersremoveDataConsumer(state, payload) {
      const { dataConsumerId } = payload;
      state.dataConsumers = state.dataConsumers.filter(consumer => consumer.id !== dataConsumerId);
    },

    /////

    //data producers

    DataProducerssetRoomState(state, payload) {
      if (payload.state === "closed") {
        state.dataProducers = [];
      }
    },

    DataProducersaddDataProducer(state, payload) {
      const { dataProducer } = payload;
      state.dataProducers.push(dataProducer);
    },

    DataProducersremoveDataProducer(state, payload) {
      const { dataProducerId } = payload;
      state.dataProducers = state.dataProducers.filter(consumer => consumer.id !== dataProducerId);
    },

    //

    //me

    MesetRoomState(state, payload) {
      if (payload.state === "closed") {
        state.me.webcamInProgress = false;
        state.me.shareInProgress = false;
        state.me.audioOnly = false;
        state.me.audioOnlyInProgress = false;
        state.me.audioMuted = false;
        state.me.restartIceInProgress = false;
      }
    },

    MesetMe(state, payload) {
      const { peerId, displayName, image, displayNameSet, device, title } = payload;
      state.me.id = peerId;
      state.me.displayName = displayName;
      state.me.image = image;
      state.me.displayNameSet = displayNameSet;
      state.me.device = device;
      state.me.title = title;
    },

    MesetMediaCapabilities(state, payload) {
      const { canSendMic, canSendWebcam } = payload;

      state.me.canSendMic = canSendMic;
      state.me.canSendWebcam = canSendWebcam;
    },

    MesetCanChangeWebcam(state, payload) {
      const { canChangeWebcam } = payload;

      state.me.canChangeWebcam = canChangeWebcam;
    },

    MesetWebcamInProgress(state, payload) {
      const { flag } = payload;

      state.me.webcamInProgress = flag;
    },

    MesetShareInProgress(state, payload) {
      const { flag } = payload;

      state.me.shareInProgress = flag;
    },

    MesetDisplayName(state, payload) {
      const { displayName } = payload;

      if (displayName) {
        state.me.displayName = displayName;
      }
    },

    MesetAudioOnlyState(state, payload) {
      const { enabled } = payload;

      state.me.audioOnly = enabled;
    },

    MesetAudioOnlyInProgress(state, payload) {
      const { flag } = payload;

      state.me.audioOnlyInProgress = flag;
    },

    MesetAudioMutedState(state, payload) {
      const { enabled } = payload;

      state.me.audioMuted = enabled;
    },

    MesetRestartIceInProgress(state, payload) {
      const { flag } = payload;

      state.me.restartIceInProgress = flag;
    },

    //

    //notifications

    NotificationsaddNotification(state, payload) {
      const notification = payload;

      alert(JSON.stringify(notification));

      state.notifications.push(notification);
    },

    NotificationsremoveNotification(state, payload) {
      const { notificationId } = payload;

      state.notifications = state.notifications.filter(notification => notification.id !== notificationId);
    },

    NotificationsremoveAllNotifications(state) {
      state.notifications = [];
    },

    //

    //peers

    PeerssetRoomState(state, payload) {
      if (payload.state === "closed") {
        state.peers = [];
      }
    },

    PeersaddPeer(state, payload) {
      const { peer } = payload;

      state.peers.push(peer);
    },

    PeersremovePeer(state, payload) {
      const { peerId } = payload;

      state.peers = state.peers.filter(peer => peer.id !== peerId);
    },

    PeerssetPeerDisplayName(state, payload) {
      const { displayName, peerId } = payload;
      const peer = state.peers.find(peer => peer.id === peerId);

      if (!peer) {
        throw new Error("no Peer found");
      }

      state.peer.displayName = displayName;
    },

    PeersaddConsumer(state, payload) {
      const { consumer, peerId } = payload;
      const peer = state.peers.find(peer => peer.id === payload.peerId);

      if (!peer) {
        throw new Error("no Peer found for new Consumer");
      }

      peer.consumers.push(consumer.id);
    },

    PeersremoveConsumer(state, payload) {
      const { consumerId, peerId } = payload;
      const peer = state.peers.find(peer => peer.id === peerId);

      // NOTE: This means that the Peer was closed before, so it's ok.
      if (!peer) {
        return;
      }

      peer.consumers = peer.consumers.filter(consumer => consumer === consumerId);
    },

    PeersaddDataConsumer(state, payload) {
      const { dataConsumer, peerId } = payload;

      // special case for bot DataConsumer.
      if (!peerId) {
        return;
      }

      const peer = state.peers.find(peer => peer.id === peerId);

      if (!peer) {
        throw new Error("no Peer found for new DataConsumer");
      }

      peer.dataConsumers.push(dataConsumer.id);
    },

    PeersremoveDataConsumer(state, payload) {
      const { dataConsumerId, peerId } = payload;

      // special case for bot DataConsumer.
      if (!peerId) {
        return;
      }

      const peer = state.peers.find(peer => peer.id === peerId);

      // NOTE: This means that the Peer was closed before, so it's ok.
      if (!peer) {
        return;
      }

      peer.dataConsumers = peer.dataConsumers.filter(dataConsumer => dataConsumer === dataConsumerId);
    },

    //

    //producers

    ProducerssetRoomState(state, payload) {
      if (payload.state === "closed") {
        state.producers = [];
      }
    },

    ProducersaddProducer(state, payload) {
      const { producer } = payload;
      state.producers.push(producer);
    },

    ProducersremoveProducer(state, payload) {
      const { producerId } = payload;

      state.producers = state.producers.filter(producer => producer.id !== producerId);
    },

    ProducerssetProducerPaused(state, payload) {
      const { producerId } = payload;

      const producer = state.producers.find(producer => producer.id === producerId);

      producer.paused = true;
    },

    ProducerssetProducerResumed(state, payload) {
      const { producerId } = payload;

      const producer = state.producers.find(producer => producer.id === producerId);

      producer.paused = false;
    },

    ProducerssetProducerTrack(state, payload) {
      const { producerId, track } = payload;

      const producer = state.producers.find(producer => producer.id === producerId);

      producer.track = track;
    },

    ProducerssetProducerScore(state, payload) {
      const { producerId, score } = payload;

      const producer = state.producers.find(producer => producer.id === producerId);
      if (producer != null && producer != undefined) {
        producer.score = score;
      }
    },

    //

    //room

    RoomsetRoomUrl(state, payload) {
      state.url = payload.url;
    },

    RoomsetRoomState(state, payload) {
      const roomState = payload.state;

      if (roomState !== "connected") {
        state.state = roomState;
        state.activeSpeakerId = null;
        state.statsPeerId = null;
      } else {
        state.state = roomState;
      }
    },

    RoomsetRoomActiveSpeaker(state, payload) {
      const { peerId } = payload;

      state.activeSpeakerId = peerId;
    },

    RoomsetRoomStatsPeerId(state, payload) {
      const { peerId } = payload;

      if (state.statsPeerId === peerId) {
        state.statsPeerId = null;
      }

      state.statsPeerId = peerId;
    },

    RoomsetFaceDetection(state, payload) {
      const { flag } = payload;

      state.faceDetection = flag;
    },

    RoomremovePeer(state, payload) {
      const { peerId } = payload;

      if (peerId && peerId === state.activeSpeakerId) {
        state.activeSpeakerId = null;
      }

      if (peerId && peerId === state.statsPeerId) {
        state.statsPeerId = null;
      }
    },

    //

    setRoomUrl(state, payload) {
      state.url = payload.url;
    },

    setRoomState(state, payload) {
      const roomState = payload.state;

      if (roomState !== "connected") {
        state.state = roomState;
        state.activeSpeakerId = null;
        state.statsPeerId = null;
      } else {
        state.state = roomState;
      }
    },

    setRoomActiveSpeaker(state, payload) {
      const { peerId } = payload;

      state.activeSpeakerId = peerId;
    },

    setRoomStatsPeerId(state, payload) {
      const { peerId } = payload;

      if (state.statsPeerId === peerId) {
        state.statsPeerId = null;
      }

      state.statsPeerId = peerId;
    },

    setFaceDetection(state, payload) {
      const { flag } = payload;

      state.faceDetection = flag;
    },

    removePeer(state, payload) {
      const { peerId } = payload;

      if (peerId && peerId === state.activeSpeakerId) {
        state.activeSpeakerId = null;
      }

      if (peerId && peerId === state.statsPeerId) {
        state.statsPeerId = null;
      }
    }
  },
  actions: {
    async getUser(store, payload) {
      var res = await axios.post("account/get");
      if (!res.data.hasError) {
        store.commit("setUser", res.data.data.user);
      }
    },
    async activateEvent(store, payload) {
      var response = await axios.post("/Participant/ActivateEvent", {
        activationCode: payload.activationCode.substr(0, 6) + "-" + payload.activationCode.substr(6)
      });
      store.commit("setEventLoading", false);
      if (response.status == 200) {
        if (response.data.hasError == false) {
          await this.dispatch("getEvent", {
            id: response.data.data.eventId,
            route: true
          });
        } else {
          Message.error(response.data.message);
        }
      }
    },

    async getEvent(store, payload) {
      store.state.eventLoading = true;
      this.commit("setLoading", true);
      store.state.event = null;
      store.state.participant = null;
      axios.defaults.headers["eventID"] = payload.id;
      store.state.event = {
        id: payload.id
      };

      var response = await axios.post("/Explore/GetEvent", { id: payload.id });

      this.commit("setEvent", response.data.data.item);
      this.commit("setOrganisation", response.data.data.organization);
      this.commit("setAttending", response.data.data.isAttending);

      if (response.data.data.isAttending) {
        axios.defaults.headers["eventID"] = response.data.data.item.id;
        var getParticipantResponse = await axios.post("/Participant/GetCurrentParticipant", {});
        if (!getParticipantResponse.data.hasError) {
          store.state.participant = getParticipantResponse.data.data;
        }
      }

      this.dispatch("getRegistrationFormUrls", {});

      if (payload.route == true) {
        router.push({ name: "event", params: { id: store.state.event.slug } });
      }
    },
    async getEventBySlug(store, payload) {
      store.state.eventLoading = true;
      this.commit("setLoading", true);
      store.state.event = null;
      store.state.participant = null;
      axios.defaults.headers["eventID"] = payload.id;
      store.state.event = {
        id: payload.id
      };

      var response = await axios.post("/Explore/GetEventBySlug", { slug: payload.slug });

      this.commit("setEvent", response.data.data.item);
      this.commit("setOrganisation", response.data.data.organization);
      this.commit("setAttending", response.data.data.isAttending);

      if (response.data.data.isAttending) {
        axios.defaults.headers["eventID"] = response.data.data.item.id;
        var getParticipantResponse = await axios.post("/Participant/GetCurrentParticipant", {});
        if (!getParticipantResponse.data.hasError) {
          store.state.participant = getParticipantResponse.data.data;
        }
      }

      this.dispatch("getRegistrationFormUrls", {});

      if (payload.route == true) {
        router.push({ name: "event", params: { id: store.state.event.slug } });
      }
    },

    async getParticipants(store, payload) {
      store.state.eventLoading = "participants";
      this.commit("setLoading", true);
      store.state.participants = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Participant/GetParticipants", {
        groupID: payload.GroupId,
        subEventID: payload.subEventId,
        searchTerm: payload.searchTerm,
        skip: payload.skip,
        take: payload.take
      });
      this.commit("setParticipants", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getMySubEventRegistrations(store, payload) {
      store.state.eventLoading = "subeventregistrations";
      this.commit("setLoading", true);
      store.state.mysubeventregistrations = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Participant/GetMySubEventRegistrations", { payload });
      this.commit("setSubEventRegistrations", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getMyProgramRates(store, payload) {
      store.state.eventLoading = "programrates";
      this.commit("setLoading", true);
      store.state.myProgramRates = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Participant/GetMyProgramRates", { payload });
      this.commit("setMyProgramRates", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getProgramRates(store, payload) {
      store.state.eventLoading = "programrates";
      this.commit("setLoading", true);
      store.state.programRates = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Participant/GetProgramRates", { ...payload, skip: 0, take: 1000 });
      this.commit("setProgramRates", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getGroups(store, payload) {
      store.state.eventLoading = "groups";
      this.commit("setLoading", true);
      store.state.groups = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      setTimeout(async () => {
        var response = await axios.post("/Explore/ListGroups", { skip: 0, take: 1000 });
        this.commit("setGroups", response.data.data.items);
        store.state.eventLoading = false;
      }, 500);
    },

    async getSponsors(store, payload) {
      store.state.eventLoading = "sponsors";
      this.commit("setLoading", true);
      store.state.sponsors = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListSponsors", { ids: payload.ids, skip: 0, take: 1000 });
      this.commit("setSponsors", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getSponsorCategories(store, payload) {
      store.state.eventLoading = "sponsors";
      this.commit("setLoading", true);
      store.state.sponsorCategories = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListSponsorCategories", { ids: payload.ids, skip: 0, take: 1000 });
      this.commit("setSponsorCategories", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getSpeakers(store, payload) {
      store.state.eventLoading = "speakers";
      this.commit("setLoading", true);
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListSpeakers", { ids: payload.ids, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setSpeakers", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getSpeaker(store, payload) {
      store.state.sessionLoadingID = payload;
      this.commit("setLoading", true);
      store.state.currentSpeaker = null;
      store.state.currentSpeakerPrograms = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Explore/GetSpeaker", { id: payload, includePrograms: true });
      if (response.data.hasError == false) {
        this.commit("setCurrentSpeaker", response.data.data.item);
        this.commit("setCurrentSpeakerPrograms", response.data.data.program.items);
        window.vm.$root.$emit("speakerModalVisible");
      } else {
        window.vm.$root.$emit("error", response.data.message);
      }
      store.state.sessionLoadingID = null;
    },

    async getPrograms(store, payload) {
      store.state.eventLoading = "program";
      this.commit("setLoading", true);
      store.state.program = [];
      store.state.programDays = [];
      store.state.programSaloons = [];
      store.state.programSpeakers = [];
      store.state.subEvents = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListPrograms", { ids: payload.ids, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setProgram", response.data.data.items);
      this.commit("setProgramDays", response.data.data.days);
      this.commit("setProgramSaloons", response.data.data.saloons);
      this.commit("setProgramSpeakers", response.data.data.speakers);
      this.commit("setSubEvents", response.data.data.subEvents);
      store.state.eventLoading = false;
    },

    async getProgram(store, payload) {
      store.state.sessionLoadingID = payload;
      this.commit("setLoading", true);
      store.state.currentProgram = null;
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Explore/GetProgram", { id: payload });
      if (response.data.hasError == false) {
        this.commit("setCurrentProgram", response.data.data.item);
        window.vm.$root.$emit("programModalVisible");
      } else {
        window.vm.$root.$emit("error", response.data.alert.message);
      }
      store.state.sessionLoadingID = null;
    },

    async getDocuments(store, payload) {
      store.state.eventLoading = "documents";
      this.commit("setLoading", true);
      store.state.documents = [];
      // await this.dispatch("getDocumentCategories", { ids: payload.ids, id: this.currentEvent.id, route: false });
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListDocumentsQuery", { ids: payload.ids, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setDocuments", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getDocumentCategories(store, payload) {
      store.state.eventLoading = "documents";
      this.commit("setLoading", true);
      store.state.documentCategories = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListDocumentCategories", { ids: payload.ids, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setDocumentCategories", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getFaqs(store, payload) {
      store.state.eventLoading = "faqs";
      this.commit("setLoading", true);
      store.state.faqs = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListFaqs", { ids: payload.ids, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setFaqs", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getAlbum(state, payload) {
      store.state.eventLoading = "album";
      this.commit("setLoading", true);
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListEventAlbums", { ids: payload.ids, type: payload.type, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setAlbum", response.data.data.items);
      store.state.eventLoading = false;
    },
    async getAlbumSocial(store, payload) {
      store.state.eventLoading = "album";
      axios.defaults.headers["eventID"] = payload.id;
      var res = await axios.post("/SocialHub/List", { skip: store.state.socialAlbumList.length, take: 24, hasImage: true });
      if (!res.data.hasError) {
        this.commit("setSocialAlbumList", res.data.data.items);
      }
      store.state.eventLoading = false;
      return res;
    },

    async getMaps(state, payload) {
      state.eventLoading = "maps";
      this.commit("setLoading", true);
      state.maps = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Explore/ListAreaMaps", { ids: payload.ids, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setMaps", response.data.data.items);
      state.eventLoading = false;
    },

    async getSessions(store, payload) {
      store.state.eventLoading = "sessions";
      this.commit("setLoading", true);
      store.state.sessions = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/LiveEvent/List", { ids: payload.ids, isActive: true, sessionType: payload.type, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setSessions", response.data.data.items);
      store.state.eventLoading = false;
    },

    async getSession(store, payload) {
      this.commit("setLoading", true);
      // store.state.currentSession = null;
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/LiveEvent/Get", { id: payload.id });

      response.data.data.item.participants = response.data.data.participants;

      store.commit("setCurrentSession", response.data.data.item);
      return response;
    },

    async joinSession(store, payload) {
      store.state.sessionLoadingID = payload;
      var response = await axios.post("/LiveEvent/Join", { id: payload });
      if (response.data.hasError == false) {
        var res = await this.dispatch("getSession", { id: payload, route: false });
        if (!res.data.hasError) {
          store.commit("setLiveSessionHash", response.data.data.hashOnyl);
          router.push({ name: "session", params: { session_id: payload } }).catch(e => {});
        }
      } else {
        Message.error(response.data.message);
      }
      store.state.sessionLoadingID = null;
    },

    async getRooms(store, payload) {
      store.state.eventLoading = "rooms";
      this.commit("setLoading", true);
      store.state.rooms = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/LiveEvent/ListNetworkingAreas", { ids: payload.ids, isActive: true, searchTerm: payload.searchTerm, skip: 0, take: 1000 });
      this.commit("setRooms", response.data.data.items);
      store.state.eventLoading = false;
    },

    async joinRoom(store, payload) {
      store.state.sessionLoadingID = payload;
      this.commit("setLoading", true);
      store.state.currentRoom = null;
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/LiveEvent/GetNetworkingArea", { id: payload });
      if (response.data.hasError == false) {
        this.commit("setCurrentRoom", response.data.data.item);
        router.push({ name: "room", params: { network_id: payload } }).catch({});
      } else {
        window.vm.$root.$emit("error", response.data.message);
      }
      store.state.sessionLoadingID = null;
      return response;
    },

    async getBooths(store, payload) {
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("Stand/List", { ...payload, skip: (payload.page - 1) * payload.take, isActive: true });
      // var response = await axios.post("/Stand/List", { ids: payload.ids, searchTerm: payload.searchTerm, saloonID: payload.saloonId, isActive: true, skip:0, take:1000, });
      this.commit("setBooths", response.data.data.items);
      return response;
    },

    async getBoothSaloons(store, payload) {
      store.state.eventLoading = "booths";
      this.commit("setLoading", true);
      store.state.boothSaloons = [];
      axios.defaults.headers["eventID"] = payload.id;
      var response = await axios.post("/Stand/ListSaloons", { ids: payload.ids, searchTerm: payload.searchTerm, isActive: true, skip: 0, take: 1000 });
      this.commit("setBoothSaloons", response.data.data.items);
      store.state.eventLoading = false;
    },

    async joinBooth(store, payload) {
      store.state.sessionLoadingID = payload;
      this.commit("setLoading", true);
      store.state.currentBooth = null;
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Stand/Get", { id: payload });
      if (response.data.hasError == false) {
        this.commit("setCurrentBooth", response.data.data.item);
        router.push({ name: "booth", params: { stand_id: payload } });
      } else {
        window.vm.$root.$emit("error", response.data.message);
      }
      store.state.sessionLoadingID = null;
    },

    //registrationFormUrls

    async getRegistrationFormUrls(store, payload) {
      store.state.eventLoading = "registrationForms";
      this.commit("setLoading", true);
      store.state.registrationFormUrls = [];
      axios.defaults.headers["eventID"] = store.state.event.id;
      var response = await axios.post("/Registration/GetRegistrationFormUrls", {});
      this.commit("setRegistrationFormUrls", response.data.data.items);
      store.state.eventLoading = false;
    },

    async notify(data) {
      // debugger;
      // window.vm.$root.$emit("error", data.text);
    }

    // connectSession(state, payload) {
    //     this.commit("setTokbox", session);
    // },
  },
  getters: {
    getUser: state => state.user,
    getResponse: state => state.response,
    getLoading: state => state.eventLoading,
    getEvent: state => state.event,
    getSocialAlbum: state => state.socialAlbumList,
    getOrganisation: state => state.organisation,
    getAttending: state => state.isAttending,
    getMySubEventRegistrations: state => state.mysubeventregistrations,
    getMyProgramRates: state => state.myProgramRates,
    getProgramRates: state => state.programRates,
    getApplication: state => state.application,
    getSponsors: state => state.sponsors,
    getSponsorCategories: state => state.sponsorCategories,
    getSpeakers: state => state.speakers,
    getCurrentSpeaker: state => state.currentSpeaker,
    getCurrentSpeakerPrograms: state => state.currentSpeakerPrograms,
    getPrograms: state => state.program,
    getCurrentProgram: state => state.currentProgram,
    getProgramDays: state => state.programDays,
    getProgramSaloons: state => state.programSaloons,
    getProgramSpeakers: state => state.programSpeakers,
    getSubEvents: state => state.subEvents,
    getDocuments: state => state.documents,
    getRegistrationFormUrls: state => state.registrationFormUrls,
    getDocumentCategories: state => state.documentCategories,
    getFaqs: state => state.faqs,
    getAlbum: state => state.album,
    getMaps: state => state.maps,
    getGroups: state => state.groups,
    getSessions: state => state.sessions,
    getCurrentSession: state => state.currentSession,
    getRooms: state => state.rooms,
    getCurrentRoom: state => state.currentRoom,
    getBooths: state => state.booths,
    getBoothSaloons: state => state.boothSaloons,
    getCurrentBooth: state => state.currentBooth,
    getMobileBackPath: state => state.mobileBackPath,
    getLiveSessionHash: state => state.liveSesionHash
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js